import React from "react"
import {FormattedMessage} from "react-intl"
import {InvoiceDto} from "../../../state/invoice/models"
import Proposal from "../../../state/proposal/Proposal"
import Integrations from "../../../integration/Integrations"
import {EventObjectDto} from "../../../state/event/Event"
import {INTEGRATION_KEY} from "../../../state/integration/Constants"
import { BILLING_TYPE } from"../../../state/invoice/InvoiceBillingType"

const IntegrationKey = INTEGRATION_KEY.VEND
type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceExportedToVendEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = Integrations.getExternalOrderUrl(props.object)

    const renderMessage = () => {
        switch (type) {
        case "main":
            return !isReturn() ?
                <FormattedMessage
                    id="invoice.analytics.events.exported.vend.text"
                    defaultMessage="Invoice {identifier} has been exported to {integrationKey} as a completed sale"
                    values={{
                        integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.VEND),
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                /> :
                <FormattedMessage
                    id="invoice.analytics.events.return_exported.vend.text"
                    defaultMessage="Return {identifier} has been exported to {integrationKey}"
                    values={{
                        integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.VEND),
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                />
        case "void":
            return <FormattedMessage
                id="invoice.analytics.events.exported.vend.void_text"
                defaultMessage="Invoice {identifier} has been refunded in {integrationKey}"
                values={{
                    integrationKey: Integrations.getIntegrationNameFromKey(INTEGRATION_KEY.VEND),
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        case "invoice-adjustment":
            return <></>
        case "payment-adjustment":
            return <></>
        case "inventory-adjustment":
            return <></>
        default:
            return <></>
        }
    }

    const isReturn = () => {
        return props.invoice && props.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {renderMessage()}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(IntegrationKey, 120, 30)}
                    </a>
                </div>
                {Url &&
                <div className={""}>
                    <p className={"mb-0"}>
                        <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                            {Integrations.getPaymentExportedCtaFormattedMessage(props.object)}
                        </a>
                    </p>
                </div>
                }
            </div>
        </div>
    )
}


export default InvoiceExportedToVendEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-vend.component.tsx